import { WAREHOUSE_CRITERIA_ARGUMENTS } from './static-criteria-arguments';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';

import type { CriteriaInformations, ExistingFiltersHelpers, FilterBy } from './types';

export const warehouseFilterBy: FilterBy = {
  id: 'warehouse',
  type: OptionFormTypes.TYPE_CHECKLIST,
  filterValue: 'Warehouse',
  displayName: 'Warehouse',
  shouldHideActionButtons: true,
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,
  render: (criteriaInformations: CriteriaInformations, existingFiltersHelpers?: ExistingFiltersHelpers) => {
    if (!existingFiltersHelpers) {
      return null;
    }
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
};

export const warehouseCriteriaArguments = WAREHOUSE_CRITERIA_ARGUMENTS;
